import { render } from "./CommonPage.vue?vue&type=template&id=1ee6e839&ts=true"
import script from "./CommonPage.vue?vue&type=script&lang=ts"
export * from "./CommonPage.vue?vue&type=script&lang=ts"

import "./CommonPage.vue?vue&type=style&index=0&id=1ee6e839&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__